'use client';
import classNames from 'classnames';
import { getImageProps } from 'next/image';

import styles from '@/components/global/heroes/hero-image.module.scss';
import {default as Image} from '@/components/global/images/resized-cdn-image';
import React, { useState } from 'react';

interface Props {
  alternateText?: string;
  desktopSrc?: string;
  hasResults?: boolean;
  hasSrc?: boolean;
  isBusRoute?: boolean;
  isBusStation?: boolean;
  isBusTickets?: boolean;
  isSchedules?: boolean;
  mobileSrc?: string;
  tabletSrc?: string;
  priority?: boolean;
}

const HeroImage = (props: Props) => {
  const {
    alternateText,
    desktopSrc,
    hasResults,
    hasSrc,
    isBusRoute,
    isBusStation,
    isBusTickets,
    isSchedules,
    mobileSrc,
    tabletSrc,
    priority = true
  } = props;
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
  const isTablet = typeof window !== 'undefined' && window.innerWidth <= 1279 && !isMobile;
  const isDesktop = !isMobile && !isTablet;

  let src = undefined;
  if (isDesktop) {
    src = desktopSrc ?? '/assets/images/global/heroes/schedules_desktop@2x.jpg';
  } else if (isTablet) {
    src = tabletSrc ?? '/assets/images/global/heroes/schedules_tablet@2x.jpg';
  } else {
    src = mobileSrc ?? '/assets/images/global/heroes/schedules_mobile@2x.jpg';
  }

  return (
    <div
      className={classNames({
        [styles['two-background-wrapper']]: !isBusRoute && hasSrc,
        [styles['one-background-wrapper']]: !hasSrc,
        [styles['bus-station-background-wrapper']]: isBusStation,
        [styles['schedules-background-wrapper']]: isSchedules,
        [styles['has-background']]: true,
        [styles.cover]: hasResults,
        [styles.fill]: !isBusStation && !hasResults,
        [styles['cover-and-top']]: isBusStation && !hasResults,
        [styles['schedules-no-src']]: !isBusStation && !hasSrc,
        [styles['bus-route-background-wrapper']]: isBusRoute
      })}
    >
      <Image
        src={src}
        alt={alternateText ?? 'Road traveling into scenic woods'}
        priority={true}
        fetchPriority="high"
        className={styles['is-background']}
        aria-hidden={true}
        layout="fill"
        style={{ width: '100%', objectPosition: 'center' }}
        quality={isDesktop ? 80 : 70}
      />
      <div
        className={classNames({
          [styles['is-background']]: true,
          [styles['is-bus-tickets']]: !!isBusTickets,
          [styles['two-bg-image']]: !isBusRoute && hasSrc,
          [styles['one-bg-image']]: !hasSrc,
          [styles['three-bg-image']]: isBusRoute
        })}
      ></div>
    </div>
  );
};

export default HeroImage;
